var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRemove = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 96 96",
    height: "96px",
    id: "delete",
    viewBox: "0 0 96 96",
    width: "96px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84,20c2.206,0,4,1.794,4,4v48c0,2.206-1.794,4-4,4H35.593L10.704,48l24.889-28H84 M84,12H32L0,48l32,36h52  c6.627,0,12-5.373,12-12V24C96,17.373,90.627,12,84,12L84,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.657,48l8.485-8.485c1.562-1.562,1.562-4.095,0-5.657c-1.562-1.562-4.096-1.562-5.657,0L60,42.343l-8.485-8.485  c-1.562-1.562-4.095-1.562-5.657,0s-1.562,4.095,0,5.657L54.343,48l-8.485,8.485c-1.562,1.562-1.562,4.095,0,5.657  c1.562,1.562,4.095,1.562,5.657,0L60,53.657l8.485,8.485c1.562,1.562,4.095,1.562,5.657,0c1.562-1.562,1.562-4.096,0-5.657  L65.657,48z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRemove, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/remove.07d9e46f.svg";
export { ForwardRef as ReactComponent };